    (function() {
      const productPath = window.location.pathname;
      if (!productPath.includes('/products/')) return;

      const productHandle = productPath.split('/products/')[1].split('?')[0];
      let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

      if (!recentlyViewed.includes(productHandle)) {
        recentlyViewed.unshift(productHandle);
        if (recentlyViewed.length > 8) {
          recentlyViewed = recentlyViewed.slice(0, 8);
        }
        localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
      }
    })();
    
    document.addEventListener('DOMContentLoaded', function() {
      const cartDrawer = document.getElementById('Cart-Drawer');
      if (!cartDrawer) return;

      let isUpdating = false;

      document.addEventListener('cart:updated', function(event) {
        if (isUpdating) return;
        
        isUpdating = true;
        
        fetch('/cart', {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          
          const newCartDrawer = tempDiv.querySelector('#Cart-Drawer');
          const currentCartDrawer = document.getElementById('Cart-Drawer');
          
          if (newCartDrawer && currentCartDrawer) {
            currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
          }
          
          const cartUpdateEvent = new CustomEvent('cart:content-updated');
          document.dispatchEvent(cartUpdateEvent);
        })
        .catch(error => {
          console.error('Cart update error:', error);
          location.reload();
        })
        .finally(() => {
          isUpdating = false;
        });
      });

      const cartPage = document.getElementById('Cart');
      if (cartPage) {
        cartPage.addEventListener('click', function(event) {
          if (event.target.closest('.remove')) {
            setTimeout(function() {
              const cartUpdatedEvent = new CustomEvent('cart:updated');
              document.dispatchEvent(cartUpdatedEvent);
            }, 300);
          }
        });
      }
    });
